export default __webpack_public_path__ + "static/media/icon-01.dee86d90.svg";